var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircleGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75c8.975 0 16.25 7.275 16.25 16.25a16.25 16.25 0 0 1-32.5 0c0-8.975 7.275-16.25 16.25-16.25zm0 2.5C12.406 6.25 6.25 12.406 6.25 20a13.75 13.75 0 0 0 27.5 0c0-7.594-6.156-13.75-13.75-13.75zm-4.634 9.116a1.25 1.25 0 0 1 1.768 0L20 18.232l2.866-2.866a1.25 1.25 0 0 1 1.628-.12l.14.12a1.25 1.25 0 0 1 0 1.768L21.768 20l2.866 2.866a1.25 1.25 0 0 1 .12 1.628l-.12.14a1.25 1.25 0 0 1-1.768 0L20 21.768l-2.866 2.866a1.25 1.25 0 0 1-1.628.12l-.14-.12a1.25 1.25 0 0 1 0-1.768L18.232 20l-2.866-2.866a1.25 1.25 0 0 1-.12-1.628l.12-.14z",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleGray);
export default __webpack_public_path__ + "static/media/x-circle-gray.1a7418a7adc294793a4a1cf8f3eaa66c.svg";
export { ForwardRef as ReactComponent };